module.exports = __webpack_public_path__ + "static/footerlogoa-ab81907558232defc4460b200a548aa2.png";